import { apiClient } from '@/shared/services/api';
import type { ApiResponse } from './authApi';
import type { AuthUser } from '../stores/authStore';

export interface UpdateProfileRequest {
  firstName: string;
  otherNames: string;
  phoneNumber: string | null;
}

export const profileApi = {
  updateProfile: async (payload: UpdateProfileRequest): Promise<AuthUser> => {
    const { data } = await apiClient.patch<ApiResponse<AuthUser>>('/Users/me', payload);
    return data.data;
  },
};
